import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

import { AdobeLaunchService } from './adobe-launch/adobe-launch.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  public environment = environment;

  constructor(private readonly adobeLaunchService: AdobeLaunchService) {}
}
